module.exports = __webpack_public_path__ + "img/hero-image.ac1e51f1.png";